import { NgModule } from '@angular/core';
import { RouterModule, TitleStrategy } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitleStrategy } from './translation/custom-title-strategy';

@NgModule({
    imports: [
        TranslateModule,
        RouterModule.forRoot([{ path: '', loadChildren: () => import('./cdep/cdep.module').then((m) => m.CdepModule) }], {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
        }),
    ],
    exports: [RouterModule],
    providers: [
        {
            provide: TitleStrategy,
            useClass: CustomTitleStrategy,
        },
    ],
})
export class AppRoutingModule {}
